import { GET_IMAGE_UPLOAD, GET_USER, GET_USER_UPDATE } from "../ConstAction";

export const uploadImage = (data, file_id, setLoading) => {
  return {
    type: GET_IMAGE_UPLOAD,
    data: data,
    file_id: file_id,
    setLoading: setLoading
  };
};

export const userupdate = (response, data, setLoading) => {
  return {
    type: GET_USER_UPDATE,
    response: response,
    data: data,
    setLoading: setLoading,
  };
};

export const users = (data,setLoading) => {
  return {
    type: GET_USER,
    data: data,
    setLoading:setLoading
  };
};
